(() => {
  const root = document.getElementById('ra-wheel');
  if (!root || !window.HTMLDialogElement || document.body.classList.contains('template-cart')) return;
  const cartDrawer = document.getElementById('MinimogCartDrawer');
  const cartIsOpen = () => !!cartDrawer?.classList.contains('m-cart-drawer--active');
  const dialog = root.querySelector('dialog');
  const backdrop = root.querySelector('.ra-backdrop');
  const teaser = root.querySelector('.ra-teaser');
  const launcher = root.querySelector('.ra-launcher');
  const launcherClose = root.querySelector('.ra-launcher-close');
  const close = root.querySelector('.ra-close');
  const form = root.querySelector('form');
  const submitButton = form.querySelector('button[type="submit"]');
  const submitStatus = root.querySelector('.ra-submit-status');
  const submitLabel = submitButton?.textContent;
  let submitTimer;
  let restoreOverflow;
  const result = root.querySelector('.ra-result');
  const wait = root.querySelector('.ra-wait');
  const dial = root.querySelector('.ra-dial');
  const awardNote = root.querySelector('.ra-award-note');
  const countdown = root.querySelector('.ra-countdown');
  const timeText = root.querySelector('.ra-time');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const preview = root.dataset.preview === 'true';
  const known = root.dataset.customerKnown === 'true';
  const redeemed = root.dataset.redeemed === 'true';
  const duration = 21600;
  const dismissalDuration = 2 * 60 * 60 * 1000;
  const serverAtLoad = Number(root.dataset.serverNow) * 1000 || Date.now();
  const monotonicAtLoad = performance.now();
  const now = () => serverAtLoad + performance.now() - monotonicAtLoad;
  const storage = {
    get: key => { try { return sessionStorage.getItem(key); } catch { return null; } },
    set: (key, value) => { try { sessionStorage.setItem(key, String(value)); } catch {} },
    remove: key => { try { sessionStorage.removeItem(key); } catch {} }
  };
  const persistent = {
    get: key => { try { return localStorage.getItem(key) || storage.get(key); } catch { return storage.get(key); } },
    set: (key, value) => { storage.set(key, value); try { localStorage.setItem(key, String(value)); } catch {} },
    remove: key => { storage.remove(key); try { localStorage.removeItem(key); } catch {} }
  };
  const memory = preview ? storage : persistent;
  const bottomBarSelector = '.m-mobile-sticky-bar, .m-sticky-addtocart, #m-cookie-banner, .f\\:sticky-atc, .x-sticky-atc, #Avada-CookiesBar, #Avada-CookiesBar > div';
  let bottomBars = [...document.querySelectorAll(bottomBarSelector)];
  let teaserPositionQueued = false;
  const positionTeaser = () => {
    if (!teaser || teaser.hidden || teaserPositionQueued) return;
    teaserPositionQueued = true;
    requestAnimationFrame(() => {
      teaserPositionQueued = false;
      const viewportHeight = window.innerHeight;
      const middle = window.innerWidth / 2;
      const halfWidth = teaser.getBoundingClientRect().width / 2;
      let offset = 0;
      bottomBars.forEach(bar => {
        const target = bar;
        if (!target) return;
        const box = target.getBoundingClientRect();
        const style = window.getComputedStyle(target);
        if (!box.height || !box.width || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
        if (box.top >= viewportHeight || box.bottom <= viewportHeight / 2 || box.top < viewportHeight / 2) return;
        if (box.left < middle + halfWidth && box.right > middle - halfWidth) offset = Math.max(offset, viewportHeight - box.top);
      });
      const bottomOffset = Math.ceil(offset) + 'px';
      teaser.style.setProperty('--ra-teaser-offset', bottomOffset);
      document.documentElement.style.setProperty('--ra-floating-bottom-offset', bottomOffset);
    });
  };
  const showLauncher = visible => { launcher.hidden = !visible; if (launcherClose) launcherClose.hidden = !visible; if (teaser) teaser.hidden = !visible; if (visible) positionTeaser(); };
  const pending = storage.get('ra-wheel-pending') === '1';
  const completed = !!root.querySelector('[data-ra-success]') && (pending || window.location.hash === '#RaWheelNewsletter');
  const error = !!root.querySelector('.ra-errors');
  let expiry = Number(memory.get('ra-wheel-expiry')) || 0;
  let claimed = memory.get('ra-wheel-completed') === '1';
  const serverExpiry = Number(root.dataset.awardExpiry) || 0;
  const params = new URLSearchParams(window.location.search);
  const emailExpiry = Number(params.get('ra_welcome_expires')) || 0;
  const validExpiry = value => Number.isSafeInteger(value) && value > 0 && value <= Math.floor(now() / 1000) + duration + 60;
  if (!preview && redeemed) {
    persistent.set('ra-wheel-completed', '1');
    persistent.set('ra-wheel-redeemed', '1');
    persistent.remove('ra-wheel-expiry');
  }
  if (!preview && (redeemed || persistent.get('ra-wheel-redeemed') === '1')) { root.hidden = true; return; }
  // A recorded deadline can only stay the same or become earlier.
  const incomingExpiry = validExpiry(serverExpiry) ? serverExpiry : (validExpiry(emailExpiry) ? emailExpiry : 0);
  if (incomingExpiry) {
    expiry = expiry ? Math.min(expiry, incomingExpiry) : incomingExpiry;
    claimed = true;
    memory.set('ra-wheel-expiry', expiry);
    memory.set('ra-wheel-completed', '1');
  }
  if (params.has('ra_welcome_expires')) {
    params.delete('ra_welcome_expires');
    const query = params.toString();
    window.history.replaceState(window.history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
  }
  if (!preview && storage.get('ra-wheel-completed') === '1') persistent.set('ra-wheel-completed', '1');
  if (!preview && storage.get('ra-wheel-dismissed') === '1' && !persistent.get('ra-wheel-dismissed-until')) {
    persistent.set('ra-wheel-dismissed-until', Date.now() + dismissalDuration);
  }
  const activeAward = () => claimed && expiry * 1000 > now();
  if (!preview && !(completed && pending) && ((known && !activeAward()) || (claimed && !activeAward()))) {
    root.hidden = true; return;
  }
  let previousFocus;
  let timer;
  let launcherTime;
  const setTimeParts = (element, values) => {
    let digits = element.querySelectorAll('.ra-time-value');
    if (digits.length !== 3) {
      const parts = ['h', 'm', 's'].map(unit => {
        const part = document.createElement('span');
        part.className = 'ra-clock-part';
        const value = document.createElement('span');
        value.className = 'ra-time-value';
        const label = document.createElement('small');
        label.className = 'ra-time-unit';
        label.textContent = unit;
        part.append(value, label);
        return part;
      });
      element.replaceChildren(...parts);
      digits = element.querySelectorAll('.ra-time-value');
    }
    digits.forEach((digit, index) => { digit.textContent = values[index]; });
  };
  const positionPopup = () => {
    if (!dialog.open) return;
    const viewport = window.visualViewport;
    const height = viewport?.height || window.innerHeight;
    dialog.style.setProperty('--ra-viewport-height', height + 'px');
    dialog.style.top = ((viewport?.offsetTop || 0) + Math.max(12, (height - dialog.getBoundingClientRect().height) / 2)) + 'px';
  };
  const open = () => {
    if (dialog.open || root.hidden || cartIsOpen()) return;
    previousFocus = document.activeElement;
    restoreOverflow = document.body.style.overflow;
    if (backdrop) backdrop.hidden = false;
    dialog.show();
    document.body.style.overflow = 'hidden';
    const body = dialog.querySelector('.ra-dialog-body');
    if (body) body.scrollTop = 0;
    positionPopup();
    close.focus({preventScroll:true});
    storage.set('ra-wheel-shown', '1');
  };
  const closeDialog = () => {
    dialog.close();
    if (backdrop) backdrop.hidden = true;
    if (restoreOverflow !== undefined) document.body.style.overflow = restoreOverflow;
    restoreOverflow = undefined;
  };
  if (cartDrawer && window.MutationObserver) {
    const cartVisibilityObserver = new window.MutationObserver(() => {
      if (cartIsOpen() && dialog.open) closeDialog();
      if (!cartIsOpen()) positionTeaser();
    });
    cartVisibilityObserver.observe(cartDrawer, {attributes:true, attributeFilter:['class']});
  }
  const dismiss = () => {
    closeDialog();
    storage.set('ra-wheel-dismissed', '1');
    memory.set('ra-wheel-dismissed-until', Date.now() + dismissalDuration);
    if (claimed && !activeAward()) {
      root.hidden = true; showLauncher(false);
      if (previousFocus?.isConnected && !dialog.contains(previousFocus) && previousFocus !== launcher) previousFocus.focus({preventScroll:true});
    } else {
      showLauncher(true); launcher.focus({preventScroll:true});
    }
  };
  const updateCountdown = () => {
    const seconds = Math.max(0, Math.ceil(expiry - now() / 1000));
    if (!seconds) {
      if (timer) clearInterval(timer);
      countdown.hidden = true;
      showLauncher(false);
      if (dialog.open) {
        awardNote.querySelector('p').textContent = root.dataset.expired;
        positionPopup();
      } else root.hidden = true;
      return;
    }
    const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2,'0'));
    const text = values.map((value, index) => value + ['h', 'm', 's'][index]).join(' ');
    setTimeParts(timeText, values);
    if (!launcherTime) {
      const discount = document.createElement('span');
      discount.className = 'ra-launcher-discount';
      discount.textContent = '−10%';
      launcherTime = document.createElement('span');
      launcherTime.className = 'ra-launcher-time';
      launcherTime.setAttribute('aria-hidden', 'true');
      launcher.replaceChildren(discount, launcherTime);
    }
    setTimeParts(launcherTime, values);
    launcher.setAttribute('aria-label', root.dataset.countdownTeaser + ' ' + text);
    countdown.hidden = false;
  };
  const showAward = () => {
    if (submitStatus) submitStatus.hidden = true;
    form.hidden = true; wait.hidden = true; result.hidden = false; awardNote.hidden = false;
    dialog.classList.add('ra-is-spinning');
    dial.style.transform = 'rotate(1755deg)';
    if (expiry) {
      updateCountdown();
      if (activeAward()) timer = setInterval(updateCountdown, 1000);
    }
    positionPopup();
  };
  launcher.addEventListener('click', open);
  launcherClose?.addEventListener('click', () => {
    const until = Date.now() + dismissalDuration;
    closeDialog(); showLauncher(false);
    storage.set('ra-wheel-dismissed', '1');
    memory.set('ra-wheel-hidden-until', until);
    memory.set('ra-wheel-dismissed-until', until);
  });
  close.addEventListener('click', dismiss);
  backdrop?.addEventListener('click', dismiss);
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); dismiss(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button, input:not([type="hidden"]), a[href]')].filter(element => !element.disabled && !element.closest('[hidden]'));
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
  });
  window.addEventListener('resize', positionPopup, {passive:true});
  window.addEventListener('resize', positionTeaser, {passive:true});
  window.addEventListener('scroll', positionTeaser, {passive:true});
  if (teaser) {
    const resizeObserver = window.ResizeObserver ? new window.ResizeObserver(positionTeaser) : null;
    const barObserver = window.MutationObserver ? new window.MutationObserver(positionTeaser) : null;
    const refreshBottomBars = () => {
      resizeObserver?.disconnect();
      barObserver?.disconnect();
      bottomBars.forEach(bar => bar.removeEventListener('transitionend', positionTeaser));
      bottomBars = [...document.querySelectorAll(bottomBarSelector)];
      bottomBars.forEach(bar => {
        resizeObserver?.observe(bar);
        barObserver?.observe(bar, {attributes:true, attributeFilter:['class', 'style', 'hidden']});
        bar.addEventListener('transitionend', positionTeaser);
      });
      positionTeaser();
    };
    refreshBottomBars();
    if (window.MutationObserver) {
      const pageObserver = new window.MutationObserver(records => {
        const changed = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && (node.matches(bottomBarSelector) || node.querySelector(bottomBarSelector))
        ));
        if (changed) refreshBottomBars();
      });
      pageObserver.observe(document.body, {childList:true, subtree:true});
    }
  }
  window.visualViewport?.addEventListener('resize', positionPopup, {passive:true});
  window.visualViewport?.addEventListener('scroll', positionPopup, {passive:true});
  const resetSubmission = message => {
    if (submitTimer) clearTimeout(submitTimer);
    form.removeAttribute('aria-busy');
    if (submitButton) { submitButton.disabled = false; submitButton.textContent = submitLabel; }
    if (submitStatus) { submitStatus.hidden = !message; submitStatus.textContent = message || ''; }
    positionPopup();
  };
  form.addEventListener('submit', event => {
    if (claimed) { event.preventDefault(); showAward(); return; }
    if (!form.checkValidity()) return;
    const current = Math.floor(now() / 1000);
    const previous = Number(storage.get('ra-wheel-request-start'));
    const start = previous > 0 && previous <= current && current - previous < 300 ? previous : current;
    storage.set('ra-wheel-request-start', start);
    storage.set('ra-wheel-pending', '1');
    form.querySelector('[name="contact[tags]"]').value = 'newsletter,ra-welcome-wheel,ra-wheel-10-request,ra-wheel-start:' + start;
    form.setAttribute('aria-busy', 'true');
    if (submitButton) { submitButton.disabled = true; submitButton.textContent = submitButton.dataset.loading; }
    if (submitStatus) { submitStatus.hidden = false; submitStatus.textContent = submitStatus.dataset.pending; }
    if (submitTimer) clearTimeout(submitTimer);
    submitTimer = setTimeout(() => resetSubmission(submitStatus?.dataset.retry), 20000);
    positionPopup();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted && !claimed) resetSubmission(submitStatus?.dataset.retry);
  });
  if (completed) {
    storage.remove('ra-wheel-pending');
    claimed = true;
    memory.set('ra-wheel-completed', '1');
    const start = Number(storage.get('ra-wheel-request-start'));
    // Only a confirmed form submission starts a timer; reloads never renew it.
    if (!expiry && start > 0) { expiry = start + duration; memory.set('ra-wheel-expiry', expiry); }
    form.hidden = true; wait.hidden = false; open();
    requestAnimationFrame(() => { dialog.classList.add('ra-is-spinning'); dial.style.transform = 'rotate(1755deg)'; });
    setTimeout(showAward, reduced ? 0 : 4100);
  } else if (claimed) {
    showAward();
  } else if (error && pending) {
    storage.remove('ra-wheel-pending'); storage.remove('ra-wheel-request-start');
    open(); root.querySelector('[aria-invalid="true"]')?.focus();
  } else if (pending) {
    storage.remove('ra-wheel-pending'); storage.remove('ra-wheel-request-start');
    resetSubmission(submitStatus?.dataset.retry);
    open();
  }
  const visits = (parseInt(storage.get('ra-wheel-visits'),10) || 0) + 1;
  storage.set('ra-wheel-visits', visits);
  setTimeout(() => {
    if (root.hidden || (claimed && !activeAward())) return;
    const hiddenUntil = Number(memory.get('ra-wheel-hidden-until')) || 0;
    if (hiddenUntil > Date.now()) return;
    memory.remove('ra-wheel-hidden-until');
    showLauncher(true);
    const dismissedUntil = Number(memory.get('ra-wheel-dismissed-until')) || 0;
    if (dismissedUntil && dismissedUntil <= Date.now()) {
      memory.remove('ra-wheel-dismissed-until'); storage.remove('ra-wheel-dismissed'); storage.remove('ra-wheel-shown');
    }
    if (claimed) return;
    if (preview) { if (!storage.get('ra-wheel-dismissed')) open(); }
    else if (visits >= 2 && dismissedUntil <= Date.now() && !storage.get('ra-wheel-shown') && !storage.get('ra-wheel-dismissed')) open();
  }, 3000);
})();


